import { call, getContext, put, takeLatest } from 'redux-saga/effects';
import { INITIALIZE } from 'next/root/actions';
import { reject, resolve } from './actions';
import { parse } from './shape';

/**
 * TODO: Add toast notifications on success/failure
 */

/**
 * Transform overview response as entity
 *
 * @param {Response} response - Raw overview response
 * @return {Entity} Overview entity
 */
const transform = ([overview] = [{}]) => parse(overview);

function* fetchOverview() {
  try {
    const api = yield getContext('api');
    const response = yield call(api.getOverview);
    yield put(resolve(transform(response)));
  } catch (error) {
    yield put(reject(error));
  }
}

export default function* saga() {
  yield takeLatest(INITIALIZE, fetchOverview);
}
